import React from 'react';
import { Modal } from '@carbon/react';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  type: 'warning' | 'danger'
};

export const ConfirmModal: React.FC<Props> = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  type,
}) => {
  return (
    <Modal
      open={open}
      modalHeading={title}
      primaryButtonText="Yes"
      secondaryButtonText="Cancel"
      danger
      onRequestClose={onClose}
      onRequestSubmit={onConfirm}
      preventCloseOnClickOutside={true}
    >
      <p>
        {message}
      </p>
    </Modal>
  );
};
